import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEquipments, StateStatus } from '@guryou/redux';
const useEquipments = () => {
  const dispatch = useDispatch();
  const {
    data,
    status
  } = useSelector(state => state.equipments.all);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getEquipments());
    }
  }, [dispatch, status]);
  return {
    data,
    status
  };
};
export default useEquipments;